// @ts-nocheck

import { useMemo } from 'react';
import { v4 } from 'uuid';

const useUuid = () => useMemo(() => v4(), []);

export default useUuid;
